import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link, useHistory } from 'react-router-dom';
import { P, formatCurrency } from 'shared';
import { PreQualAccessForm } from '../../../credit_application/forms/PreQualAccessForm';
import { PreQualificationSubprime } from '../../../credit_application/wizard_views';
import { useEDSPreventBacktracking } from './_hooks';
import useWaterfallEDS from './_hooks/useWaterfallEDS';
import { useEDSStore } from './_store/eds.store';
import { getIntroSlug } from './_utils/getSlugs';
import { gotoResult } from './_utils/gotoURL';
import DisabledEDS from './DisabledEDS';
const WaterfallEDS = () => {
    // Vars
    const submitting = false;
    const submitButtonText = 'Submit';
    // Hooks
    const history = useHistory();
    const { postApplyAfterPrequal, getApplyAfterPrequalArgs } = useWaterfallEDS();
    useEDSPreventBacktracking({ currentPage: 'WaterfallEDS' });
    // Store
    const { edsEnabled, edsApplicant, edsOffer, edsPersonalInfo } = useEDSStore();
    if (!edsOffer) {
        return (_jsx("div", { className: "max-width-600 mar-auto text-center", children: _jsxs(P, { children: ["Please re-start the application ", _jsx(Link, { to: getIntroSlug(), children: "here" }), "."] }) }));
    }
    const prequalification = edsOffer;
    const lenderRequestReferenceId = prequalification.lenderRequestReferenceId;
    // Destructure
    const creditApplicationId = edsApplicant?.creditApplication?.applicationId;
    const personalInfo = edsPersonalInfo;
    const { offers, location } = edsOffer;
    if (!offers) {
        useEDSStore.setState({
            edsResult: {
                isFailed: true,
                lenderReferenceId: lenderRequestReferenceId,
            },
        });
        gotoResult(history);
        return;
    }
    const lenderName = offers ? offers[0].serviceProviderName : '';
    const prequalifiedCreditLimit = offers ? offers[0].amount : 0;
    const lenderProductType = offers ? offers[0].lenderProductType : '';
    const practice = location;
    // Func
    const onSubmit = async (formVals) => {
        const lenderParams = formVals.lender_required_params;
        const application = getApplyAfterPrequalArgs(prequalification.offers[0], prequalification.applicationId);
        const applicationToSubmit = {
            ...application,
            lenderRequiredParams: {
                ...lenderParams,
            },
        };
        // Post
        const resp = await postApplyAfterPrequal({
            postConsumerApplicationsV2CreditApplicationsApplyAfterPrequalification: {
                ...applicationToSubmit,
            },
        });
        // Response
        if (resp) {
            if ('data' in resp) {
                const applicationStatus = resp.data.applicationStatus;
                if (applicationStatus === 'declined') {
                    // set decline data
                    useEDSStore.setState({
                        edsResult: {
                            isDenied: true,
                        },
                    });
                }
                if (applicationStatus === 'approved') {
                    // set approved data
                    const approvedData = {
                        personalInfo,
                        practice,
                        lenderName,
                        approvedApplication: { ...resp.data },
                    };
                    useEDSStore.setState({
                        edsResult: {
                            isApproved: true,
                            ...approvedData,
                        },
                    });
                }
                if (applicationStatus !== 'declined' &&
                    applicationStatus !== 'approved') {
                    const pendingDecisionDetails = resp.data.pendingDecisionDetails;
                    if (pendingDecisionDetails &&
                        pendingDecisionDetails.url &&
                        pendingDecisionDetails.url !== '#') {
                        useEDSStore.setState({
                            edsResult: {
                                isPending: true,
                                pendingDecisionDetails,
                                personalInfo,
                                prequalification,
                            },
                        });
                        /*
                      <PendHandler
                        iframeUrl={pendingDecisionDetails.url}
                        personalInfo={personalInfo}
                        prequalification={prequalification}
                      />
                      */
                    }
                    else {
                        useEDSStore.setState({
                            edsResult: {
                                isFailed: true,
                                lenderReferenceId: lenderRequestReferenceId,
                            },
                        });
                        // <FailedMessage lenderReferenceId={lenderReferenceId} />
                    }
                }
                gotoResult(history);
            }
        }
    };
    // Success
    const onSubmitSuccess = () => { };
    // Fail
    const onSubmitFail = () => { };
    return (_jsxs("div", { className: "container max-width-800 min-height-600 mar-auto", children: [personalInfo && prequalification && (_jsxs(_Fragment, { children: [_jsx(PreQualificationSubprime, { prequalifiedLoanAmount: formatCurrency(prequalifiedCreditLimit, 2), practice: practice, lenderName: lenderName, lenderProductType: lenderProductType }), _jsx(PreQualAccessForm, { submitFunc: onSubmit, isSubmitting: submitting, onSubmitSuccess: onSubmitSuccess, onSubmitFail: onSubmitFail, submitButtonText: submitButtonText, lenderName: lenderName, locationId: practice.locationId, personalInfo: personalInfo, prequalification: prequalification })] })), (edsEnabled === null || !creditApplicationId) && (_jsx("div", { className: "container max-width-600 min-height-600 mar-auto text-center", children: _jsxs(P, { children: ["Please re-start the application", ' ', _jsx(Link, { to: getIntroSlug(), children: "here" }), "."] }) })), edsEnabled === false && _jsx(DisabledEDS, {})] }));
};
export default WaterfallEDS;
